webpackJsonp([127],{

/***/ 1287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingInstructionRecordTable_vue__ = __webpack_require__(3045);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50e74cef_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingInstructionRecordTable_vue__ = __webpack_require__(5631);
function injectStyle (ssrContext) {
  __webpack_require__(5626)
  __webpack_require__(5628)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-50e74cef"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingInstructionRecordTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50e74cef_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingInstructionRecordTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * ElementUI 日期选择组件的参数
 * @Author: anker.wang
 * @Date: 2018-01-08 11:27:07
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-01-08 11:28:27
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dateTimePickerOptions: {
        shortcuts: [{
          text: '一周后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '明天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '今天',
          onClick: function onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      dateTimePickerRangeOptions: {
        shortcuts: [{
          text: '最近1周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近6个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近2年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 730);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1095);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  }
});

/***/ }),

/***/ 1348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = trimParams;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeEmptyParams;
/* unused harmony export setParams */
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* unused harmony export conveSomeDataType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSearchParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query, to.params);
        // 设置搜索参数。 当仅 params 更新时, 需要全部重置 search 数据
        vm.setSearchParams(_.merge(vm.$options.data.call(vm).search, queryParams));
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query, to.params);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     * @param {*} params
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$route.params;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      if (params.hasOwnProperty('')) {
        delete params[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, query, params), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSearchParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSearchParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      if (params[key] && params[key].constructor === Object) {
        setParams(params[key], newParams[key]);
      } else {
        Vue.set(params, key, newParams[key]);
      }
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1353:
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(144)('meta');
var isObject = __webpack_require__(55);
var has = __webpack_require__(75);
var setDesc = __webpack_require__(54).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(76)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ 1356:
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(79);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ 1387:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(55);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),

/***/ 1420:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(54).f;
var create = __webpack_require__(240);
var redefineAll = __webpack_require__(247);
var ctx = __webpack_require__(64);
var anInstance = __webpack_require__(246);
var forOf = __webpack_require__(239);
var $iterDefine = __webpack_require__(150);
var step = __webpack_require__(251);
var setSpecies = __webpack_require__(252);
var DESCRIPTORS = __webpack_require__(40);
var fastKey = __webpack_require__(1353).fastKey;
var validate = __webpack_require__(1387);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),

/***/ 1421:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(17);
var $export = __webpack_require__(28);
var meta = __webpack_require__(1353);
var fails = __webpack_require__(76);
var hide = __webpack_require__(56);
var redefineAll = __webpack_require__(247);
var forOf = __webpack_require__(239);
var anInstance = __webpack_require__(246);
var isObject = __webpack_require__(55);
var setToStringTag = __webpack_require__(105);
var dP = __webpack_require__(54).f;
var each = __webpack_require__(1422)(0);
var DESCRIPTORS = __webpack_require__(40);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),

/***/ 1422:
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(64);
var IObject = __webpack_require__(149);
var toObject = __webpack_require__(78);
var toLength = __webpack_require__(106);
var asc = __webpack_require__(1423);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),

/***/ 1423:
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(1424);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),

/***/ 1424:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(55);
var isArray = __webpack_require__(1356);
var SPECIES = __webpack_require__(22)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ 1425:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(146);
var from = __webpack_require__(1426);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),

/***/ 1426:
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(239);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),

/***/ 1427:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(28);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),

/***/ 1428:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(28);
var aFunction = __webpack_require__(80);
var ctx = __webpack_require__(64);
var forOf = __webpack_require__(239);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),

/***/ 1443:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(992))(73);

/***/ }),

/***/ 1448:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1450), __esModule: true };

/***/ }),

/***/ 1450:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(241);
__webpack_require__(143);
__webpack_require__(234);
__webpack_require__(1451);
__webpack_require__(1452);
__webpack_require__(1453);
__webpack_require__(1454);
module.exports = __webpack_require__(12).Set;


/***/ }),

/***/ 1451:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(1420);
var validate = __webpack_require__(1387);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(1421)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),

/***/ 1452:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(28);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(1425)('Set') });


/***/ }),

/***/ 1453:
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(1427)('Set');


/***/ }),

/***/ 1454:
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(1428)('Set');


/***/ }),

/***/ 1505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return consts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return opts; });
/* harmony export (immutable) */ __webpack_exports__["g"] = getOptionLabel;
/* harmony export (immutable) */ __webpack_exports__["d"] = getCourseStatusLabel;
/* harmony export (immutable) */ __webpack_exports__["e"] = getCourseStatusType;
/* harmony export (immutable) */ __webpack_exports__["c"] = getCourseStatusActions;
/* harmony export (immutable) */ __webpack_exports__["h"] = isCourseRelationEditLocked;
/* harmony export (immutable) */ __webpack_exports__["a"] = buildCourseKnowledgeQueryParams;
/* unused harmony export COURSE_UPLOAD_TYPE_CONFIGS */
/* unused harmony export getFileExtension */
/* unused harmony export getCourseContentTypeByFile */
/* harmony export (immutable) */ __webpack_exports__["f"] = getCourseUploadConfig;
/* harmony export (immutable) */ __webpack_exports__["j"] = validateCourseUploadFile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);




var _COURSE_UPLOAD_TYPE_C;

var consts = {
  FALSE: 0,
  TRUE: 1,

  TARGETUSER_TYPE_USER: 1,
  TARGETUSER_TYPE_INTERN: 2,

  IS_COMMON_DEDICATED: 0,
  IS_COMMON_SHARED: 1,

  STATUS_NEW: 1,
  STATUS_ONLINE: 2,
  STATUS_OFFLINE: 3,
  STATUS_BANNED: 4,

  KNOWLEDGE_STATUS_ACTIVE: 2,

  CONTENT_TYPE_IMAGE: 1,
  CONTENT_TYPE_VIDEO: 2
  // CONTENT_TYPE_DOCUMENT: 3,
};

var opts = {
  contentTypeMaps: [{ value: consts.CONTENT_TYPE_IMAGE, label: '图片' }, { value: consts.CONTENT_TYPE_VIDEO, label: '视频' }],
  targetUserMaps: [{ value: consts.TARGETUSER_TYPE_USER, label: '零工', disable: false }, { value: consts.TARGETUSER_TYPE_INTERN, label: '审核实习生', disable: true }],
  isCommonMaps: [{ value: consts.IS_COMMON_DEDICATED, label: '专用' }, { value: consts.IS_COMMON_SHARED, label: '通用' }],
  statusMaps: [{ value: consts.STATUS_NEW, label: '新创建' }, { value: consts.STATUS_ONLINE, label: '已上架' }, { value: consts.STATUS_OFFLINE, label: '已下架' }, { value: consts.STATUS_BANNED, label: '已作废' }]
};

function getOptionLabel(options, value) {
  var item = options.find(function (option) {
    return Number(option.value) === Number(value);
  });
  return item ? item.label : '';
}

function getCourseStatusLabel(status) {
  return getOptionLabel(opts.statusMaps, status) || '未知状态';
}

function getCourseStatusType(status) {
  switch (Number(status)) {
    case consts.STATUS_ONLINE:
      return 'success';
    case consts.STATUS_OFFLINE:
      return 'warning';
    case consts.STATUS_BANNED:
      return 'danger';
    default:
      return 'info';
  }
}

function getCourseStatusActions(status) {
  var isSuperAdmin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  switch (Number(status)) {
    case consts.STATUS_NEW:
      return [{ name: 'online', label: '上架', type: 'success', apiName: 'onlineTrainingCourse', successText: '上架成功' }];
    case consts.STATUS_ONLINE:
      return [{ name: 'offline', label: '下架', type: 'warning', apiName: 'offlineTrainingCourse', successText: '下架成功' }];
    case consts.STATUS_OFFLINE:
      return [{ name: 'online', label: '上架', type: 'success', apiName: 'onlineTrainingCourse', successText: '上架成功' }].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(isSuperAdmin ? [{ name: 'ban', label: '作废', type: 'danger', apiName: 'banTrainingCourse', successText: '作废成功' }] : []));
    case consts.STATUS_BANNED:
      return isSuperAdmin ? [{ name: 'active', label: '激活', type: 'primary', apiName: 'activeTrainingCourse', successText: '激活成功' }] : [];
    default:
      return [];
  }
}

function isCourseRelationEditLocked(id, status) {
  return Number(id) > 0 && [consts.STATUS_ONLINE, consts.STATUS_OFFLINE].includes(Number(status));
}

function buildCourseKnowledgeQueryParams(_ref) {
  var isCommon = _ref.is_common,
      customerid = _ref.customerid;

  var params = {
    status: [consts.KNOWLEDGE_STATUS_ACTIVE],
    is_common: Number(isCommon)
  };

  if (Number(isCommon) === consts.IS_COMMON_DEDICATED && customerid) {
    params.customerid = [customerid];
  }

  return params;
}

var COURSE_UPLOAD_TYPE_CONFIGS = (_COURSE_UPLOAD_TYPE_C = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, consts.CONTENT_TYPE_IMAGE, {
  accept: ['image/jpeg', 'image/png', 'image/jpg'],
  extensions: ['jpg', 'jpeg', 'png'],
  maxFiles: 0,
  maxSizeMB: 20,
  tip: '支持 JPG、PNG，可上传多张，单个最大 20MB'
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, consts.CONTENT_TYPE_VIDEO, {
  accept: ['video/mp4', 'video/avi', 'video/x-msvideo', 'video/quicktime'],
  extensions: ['mp4', 'avi', 'mov'],
  maxFiles: 1,
  maxSizeMB: 1024,
  tip: '只能上传一个视频，支持 MP4、AVI、MOV，最大 1GB'
  // [consts.CONTENT_TYPE_DOCUMENT]: {
  //   accept: ['application/pdf'],
  //   extensions: ['pdf'],
  //   maxFiles: 1,
  //   maxSizeMB: 100,
  //   tip: '只能上传一个 PDF，最大 100MB',
  // },
}), _COURSE_UPLOAD_TYPE_C);

function getFileExtension(name) {
  var parts = String(name || '').split('.');
  return parts.length > 1 ? parts.pop().toLowerCase() : '';
}

function getCourseContentTypeByFile(file) {
  var type = String(file && file.type || '');
  var ext = getFileExtension(file && file.name);

  if (type.indexOf('image/') === 0 || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_IMAGE].extensions.includes(ext)) {
    return consts.CONTENT_TYPE_IMAGE;
  }
  if (type.indexOf('video/') === 0 || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_VIDEO].extensions.includes(ext)) {
    return consts.CONTENT_TYPE_VIDEO;
  }
  // if (type === 'application/pdf' || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_DOCUMENT].extensions.includes(ext)) {
  //   return consts.CONTENT_TYPE_DOCUMENT
  // }
  return 0;
}

function getCourseUploadConfig(contentType) {
  if (!contentType) {
    var configs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(COURSE_UPLOAD_TYPE_CONFIGS).map(function (type) {
      return COURSE_UPLOAD_TYPE_CONFIGS[type];
    });
    return {
      accept: configs.reduce(function (result, item) {
        return result.concat(item.accept);
      }, []),
      extensions: configs.reduce(function (result, item) {
        return result.concat(item.extensions);
      }, []),
      maxFiles: 0,
      maxSizeMB: Math.max.apply(null, configs.map(function (item) {
        return item.maxSizeMB;
      })),
      tip: '支持上传图片、视频；图片可上传多张，视频只能上传一个'
    };
  }

  return COURSE_UPLOAD_TYPE_CONFIGS[Number(contentType)] || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_IMAGE];
}

function validateCourseUploadFile(file) {
  var currentFiles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var currentContentType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  var contentType = getCourseContentTypeByFile(file);
  if (!contentType) {
    return {
      valid: false,
      contentType: contentType,
      message: getCourseUploadConfig().tip,
      replaceAll: false
    };
  }

  var config = getCourseUploadConfig(contentType);
  var currentCount = Array.isArray(currentFiles) ? currentFiles.length : 0;
  var maxSize = config.maxSizeMB * 1024 * 1024;
  var ext = getFileExtension(file && file.name);

  if (!file || !config.accept.includes(file.type) && !config.extensions.includes(ext)) {
    return {
      valid: false,
      contentType: contentType,
      message: config.tip,
      replaceAll: false
    };
  }

  if (Number(file.size) > maxSize) {
    return {
      valid: false,
      contentType: contentType,
      message: config.tip,
      replaceAll: false
    };
  }

  if (config.maxFiles === 1) {
    return {
      valid: true,
      contentType: contentType,
      message: '',
      replaceAll: currentCount >= 1 || currentFiles.some(function (item) {
        return Number(item.content_type || item.type || currentContentType) !== contentType;
      })
    };
  }

  return {
    valid: true,
    contentType: contentType,
    message: '',
    replaceAll: currentFiles.some(function (item) {
      return Number(item.content_type || item.type || currentContentType) !== contentType;
    })
  };
}

/***/ }),

/***/ 1526:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return consts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return opts; });
/* harmony export (immutable) */ __webpack_exports__["d"] = createOptionUuid;
/* harmony export (immutable) */ __webpack_exports__["c"] = createDefaultQuestionOptions;
/* harmony export (immutable) */ __webpack_exports__["e"] = getOptionLetter;
/* harmony export (immutable) */ __webpack_exports__["p"] = resetQuestionAnswerByType;
/* harmony export (immutable) */ __webpack_exports__["k"] = isChoiceQuestion;
/* harmony export (immutable) */ __webpack_exports__["l"] = isNumericAnswer;
/* harmony export (immutable) */ __webpack_exports__["j"] = getQuestionTypeLabel;
/* harmony export (immutable) */ __webpack_exports__["g"] = getQuestionStatusLabel;
/* harmony export (immutable) */ __webpack_exports__["h"] = getQuestionStatusType;
/* harmony export (immutable) */ __webpack_exports__["f"] = getQuestionStatusActions;
/* harmony export (immutable) */ __webpack_exports__["m"] = isQuestionRelationEditLocked;
/* unused harmony export isQuestionBaned */
/* harmony export (immutable) */ __webpack_exports__["n"] = isQuestionUsedOrBaned;
/* harmony export (immutable) */ __webpack_exports__["a"] = buildQuestionKnowledgeQueryParams;
/* harmony export (immutable) */ __webpack_exports__["i"] = getQuestionSubmitPayload;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_training_training_course_constants__ = __webpack_require__(1505);



var consts = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__views_training_training_course_constants__["b" /* consts */], {
  QUESTION_TYPE_SINGLE: 1, // 单选题
  QUESTION_TYPE_MULTI: 2, // 多选题
  QUESTION_TYPE_FILL_BLANK: 3, // 填空题

  QUESTION_STATUS_NEW: 1, // 新创建
  QUESTION_STATUS_USING: 2, // 使用中
  QUESTION_STATUS_UNUSED: 3, // 未使用
  QUESTION_STATUS_BANNED: 4 // 已作废
});

var opts = {
  targetUserMaps: __WEBPACK_IMPORTED_MODULE_1__views_training_training_course_constants__["i" /* opts */].targetUserMaps,
  isCommonMaps: __WEBPACK_IMPORTED_MODULE_1__views_training_training_course_constants__["i" /* opts */].isCommonMaps,
  statusMaps: [{ value: consts.QUESTION_STATUS_NEW, label: '新创建' }, { value: consts.QUESTION_STATUS_UNUSED, label: '未使用' }, { value: consts.QUESTION_STATUS_USING, label: '使用中' }, { value: consts.QUESTION_STATUS_BANNED, label: '已作废' }],
  questionTypeMaps: [{ value: consts.QUESTION_TYPE_SINGLE, label: '单选题' }, { value: consts.QUESTION_TYPE_MULTI, label: '多选题' }, { value: consts.QUESTION_TYPE_FILL_BLANK, label: '填空题' }]
};

function createOptionUuid() {
  return 'opt' + Math.random().toString(16).slice(2) + Date.now();
}

function createDefaultQuestionOptions() {
  return ['A', 'B', 'C', 'D'].map(function (letter) {
    return {
      uuid: createOptionUuid(),
      title: '\u9009\u9879' + letter
    };
  });
}

function getOptionLetter(index) {
  return String.fromCharCode(65 + index);
}

function resetQuestionAnswerByType(type) {
  return Number(type) === consts.QUESTION_TYPE_MULTI ? [] : '';
}

function isChoiceQuestion(type) {
  return [consts.QUESTION_TYPE_SINGLE, consts.QUESTION_TYPE_MULTI].includes(Number(type));
}

function isNumericAnswer(value) {
  return (/^-?\d+(\.\d+)?$/.test(String(value).trim())
  );
}

function getQuestionTypeLabel(value) {
  var item = opts.questionTypeMaps.find(function (option) {
    return option.value === Number(value);
  });
  return item ? item.label : '-';
}

function getQuestionStatusLabel(value) {
  var item = opts.statusMaps.find(function (option) {
    return option.value === Number(value);
  });
  return item ? item.label : '-';
}

function getQuestionStatusType(status) {
  switch (Number(status)) {
    case consts.QUESTION_STATUS_UNUSED:
      return 'success';
    case consts.QUESTION_STATUS_USING:
      return 'primary';
    case consts.QUESTION_STATUS_BANNED:
      return 'default';
    default:
      return 'warning';
  }
}

function getQuestionStatusActions(status) {
  var isSuperAdmin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (!isSuperAdmin) {
    return [];
  }
  switch (Number(status)) {
    case consts.QUESTION_STATUS_UNUSED:
    case consts.QUESTION_STATUS_NEW:
      return [{ name: 'ban', label: '作废', type: 'danger', apiName: 'banTrainingQuestion', successText: '作废成功' }];
    case consts.QUESTION_STATUS_BANNED:
      return [{ name: 'active', label: '激活', type: 'primary', apiName: 'activeTrainingQuestion', successText: '激活成功' }];
    default:
      return [];
  }
}

function isQuestionRelationEditLocked(id, status) {
  return Number(id) > 0 && [consts.QUESTION_STATUS_UNUSED, consts.QUESTION_STATUS_USING, consts.QUESTION_STATUS_BANNED].includes(Number(status));
}

function isQuestionBaned(id, status) {
  return Number(id) > 0 && Number(status) === consts.QUESTION_STATUS_BANNED;
}

function isQuestionUsedOrBaned(id, status) {
  return Number(id) > 0 && (Number(status) === consts.QUESTION_STATUS_BANNED || Number(status) === consts.QUESTION_STATUS_USING);
}

function buildQuestionKnowledgeQueryParams(form) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__views_training_training_course_constants__["a" /* buildCourseKnowledgeQueryParams */])(form);
}

function getQuestionSubmitPayload(form) {
  var payload = {
    target_usertype: form.target_usertype,
    is_common: form.is_common,
    customerid: Number(form.is_common) === consts.IS_COMMON_SHARED ? 0 : form.customerid,
    training_knowledge_id: form.training_knowledge_id,
    question_type: form.question_type,
    question_json: {
      title: form.title,
      sample_files: form.sample_files || [],
      question_analysis: {
        analysis_text: form.analysis_text || '',
        analysis_files: form.analysis_files || []
      },
      standard_answer: form.standard_answer
    }
  };

  if (isChoiceQuestion(form.question_type)) {
    payload.question_json.options = form.options || [];
  }

  return payload;
}

/***/ }),

/***/ 1550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TrainingInstructionSubHeading',
  props: {
    title: {
      type: String,
      required: true
    },
    entityId: {
      type: [Number, String],
      default: null
    },
    fallbackPath: {
      type: String,
      default: '/training/instruction'
    }
  },
  computed: {
    hasEntityId: function hasEntityId() {
      return this.entityId !== null && this.entityId !== undefined && this.entityId !== '';
    }
  },
  methods: {
    onBack: function onBack() {
      if (window.history.length > 1) {
        this.$router.back();
        return;
      }
      this.$router.push(this.fallbackPath);
    }
  }
});

/***/ }),

/***/ 1606:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildDefaultColumnConfig;
/* harmony export (immutable) */ __webpack_exports__["c"] = normalizeColumnConfig;
/* harmony export (immutable) */ __webpack_exports__["d"] = resolveVisibleColumns;
/* harmony export (immutable) */ __webpack_exports__["b"] = loadColumnConfig;
/* harmony export (immutable) */ __webpack_exports__["e"] = saveColumnConfig;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(1448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);


var STORAGE_PREFIX = 'table-column-config:';

function buildDefaultColumnConfig(definitions) {
  return definitions.map(function (col) {
    return {
      key: col.key,
      visible: col.defaultVisible !== false
    };
  });
}

function normalizeColumnConfig(definitions, savedConfig) {
  var definitionMap = _.keyBy(definitions, 'key');

  if (!savedConfig || !Array.isArray(savedConfig.columns)) {
    return buildDefaultColumnConfig(definitions);
  }

  var savedKeys = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a();
  var result = [];

  savedConfig.columns.forEach(function (item) {
    var definition = definitionMap[item.key];
    if (!definition) {
      return;
    }
    savedKeys.add(item.key);
    result.push({
      key: item.key,
      visible: definition.locked ? true : item.visible !== false
    });
  });

  definitions.forEach(function (col) {
    if (!savedKeys.has(col.key)) {
      result.push({
        key: col.key,
        visible: col.defaultVisible !== false
      });
    }
  });

  return result;
}

function resolveVisibleColumns(definitions, config) {
  var definitionMap = _.keyBy(definitions, 'key');

  return config.filter(function (item) {
    return item.visible && definitionMap[item.key];
  }).map(function (item) {
    return definitionMap[item.key];
  });
}

function loadColumnConfig(storageKey) {
  if (!storageKey) {
    return null;
  }
  try {
    var raw = localStorage.getItem('' + STORAGE_PREFIX + storageKey);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

function saveColumnConfig(storageKey, config) {
  if (!storageKey) {
    return;
  }
  localStorage.setItem('' + STORAGE_PREFIX + storageKey, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(config));
}

/***/ }),

/***/ 1607:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_utils_table_column_config__ = __webpack_require__(1606);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TableColumnConfigDialog',
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default.a
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    appliedColumns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    definitions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      sortableDraft: [],
      lockedDraft: []
    };
  },

  computed: {
    dialogVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(value) {
        this.$emit('update:visible', value);
      }
    },
    definitionMap: function definitionMap() {
      var map = {};
      this.definitions.forEach(function (item) {
        map[item.key] = item;
      });
      return map;
    }
  },
  watch: {
    visible: function visible(value) {
      if (value) {
        this.initDraft();
      }
    }
  },
  methods: {
    initDraft: function initDraft() {
      var draft = this.buildDraftItems(this.appliedColumns);
      this.sortableDraft = draft.filter(function (item) {
        return !item.locked;
      });
      this.lockedDraft = draft.filter(function (item) {
        return item.locked;
      });
    },
    buildDraftItems: function buildDraftItems(columns) {
      var _this = this;

      return columns.map(function (item) {
        var definition = _this.definitionMap[item.key] || {};
        return {
          key: item.key,
          visible: definition.locked ? true : item.visible !== false,
          label: definition.label || item.key,
          locked: !!definition.locked
        };
      });
    },
    getMergedDraft: function getMergedDraft() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.sortableDraft), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.lockedDraft)).map(function (item) {
        return {
          key: item.key,
          visible: item.visible
        };
      });
    },
    onReset: function onReset() {
      var defaultConfig = Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_table_column_config__["a" /* buildDefaultColumnConfig */])(this.definitions);
      var draft = this.buildDraftItems(defaultConfig);
      this.sortableDraft = draft.filter(function (item) {
        return !item.locked;
      });
      this.lockedDraft = draft.filter(function (item) {
        return item.locked;
      });
    },
    onCancel: function onCancel() {
      this.dialogVisible = false;
      this.$emit('cancel');
    },
    onSave: function onSave() {
      var _this2 = this;

      var draft = this.getMergedDraft();
      var visibleCount = draft.filter(function (item) {
        var definition = _this2.definitionMap[item.key] || {};
        return item.visible && !definition.locked;
      }).length;

      if (visibleCount === 0) {
        this.$message.warning('请至少保留一列');
        return;
      }

      this.$emit('save', draft);
      this.dialogVisible = false;
    },
    onClosed: function onClosed() {
      this.sortableDraft = [];
      this.lockedDraft = [];
    }
  }
});

/***/ }),

/***/ 1612:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingInstructionSubHeading_vue__ = __webpack_require__(1550);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67108e77_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingInstructionSubHeading_vue__ = __webpack_require__(1668);
function injectStyle (ssrContext) {
  __webpack_require__(1666)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67108e77"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingInstructionSubHeading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67108e77_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingInstructionSubHeading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1665:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return consts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return opts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRAINING_INSTRUCTION_TABLE_COLUMN_STORAGE_KEY; });
var consts = {
  // 布尔值
  FALSE: 0,
  TRUE: 1,

  // 所属用户类型
  TARGETUSER_TYPE_USER: 1,
  TARGETUSER_TYPE_INTERN: 2,

  // 是否通用
  IS_COMMON_DEDICATED: 0,
  IS_COMMON_SHARED: 1,

  // 培训状态
  STATUS_NEW: 1,
  STATUS_ONLINE: 2,
  STATUS_OFFLINE: 3,

  // 培训类型
  TYPE_ONLY_LEARNING: 1,
  TYPE_ONLY_EXAM: 2,
  TYPE_LEARNING_AND_EXAM: 3,

  // 考试状态
  EXAMINATION_STATUS_ONLINE: 2
};

var opts = {
  boolMaps: [{ value: consts.TRUE, label: '是' }, { value: consts.FALSE, label: '否' }],
  statusMaps: [{ value: consts.STATUS_NEW, label: '新创建' }, { value: consts.STATUS_ONLINE, label: '已上架' }, { value: consts.STATUS_OFFLINE, label: '已下架' }],
  typeMaps: [{ value: consts.TYPE_ONLY_LEARNING, label: '仅学习' }, { value: consts.TYPE_ONLY_EXAM, label: '仅考试' }, { value: consts.TYPE_LEARNING_AND_EXAM, label: '学习+考试' }],
  targetUserMaps: [{ value: consts.TARGETUSER_TYPE_USER, label: '零工', disable: false }, { value: consts.TARGETUSER_TYPE_INTERN, label: '审核实习生', disable: true }],
  isCommonMaps: [{ value: consts.IS_COMMON_DEDICATED, label: '专用' }, { value: consts.IS_COMMON_SHARED, label: '通用' }]
};

var TRAINING_INSTRUCTION_TABLE_COLUMN_STORAGE_KEY = 'training-instruction-list';

/***/ }),

/***/ 1666:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1667);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("c279ecb4", content, true, {});

/***/ }),

/***/ 1667:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".training-instruction-sub-heading[data-v-67108e77]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px;margin-bottom:16px}.training-instruction-sub-heading__back[data-v-67108e77]{-ms-flex-negative:0;flex-shrink:0}.training-instruction-sub-heading__title[data-v-67108e77]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:0;font-size:20px;font-weight:600;color:#303133;line-height:1.4}.training-instruction-sub-heading__title-text[data-v-67108e77]{min-width:0}.training-instruction-sub-heading__id-badge[data-v-67108e77]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-negative:0;flex-shrink:0;padding:2px 8px;border-radius:4px;font-size:12px;font-weight:500;line-height:20px;color:#606266;background:#f4f4f5;border:1px solid #e9e9eb;font-variant-numeric:tabular-nums}", "", {"version":3,"sources":["/workspace/src/views/training/components/TrainingInstructionSubHeading.vue"],"names":[],"mappings":"AACA,mDAAmD,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,SAAS,kBAAkB,CACpM,AACD,yDAAyD,oBAAoB,aAAa,CACzF,AACD,0DAA0D,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,QAAQ,mBAAmB,eAAe,SAAS,eAAe,gBAAgB,cAAc,eAAe,CAC/R,AACD,+DAA+D,WAAW,CACzE,AACD,6DAA6D,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,oBAAoB,cAAc,gBAAgB,kBAAkB,eAAe,gBAAgB,iBAAiB,cAAc,mBAAmB,yBAAyB,iCAAiC,CACvZ","file":"TrainingInstructionSubHeading.vue","sourcesContent":["\n.training-instruction-sub-heading[data-v-67108e77]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px;margin-bottom:16px\n}\n.training-instruction-sub-heading__back[data-v-67108e77]{-ms-flex-negative:0;flex-shrink:0\n}\n.training-instruction-sub-heading__title[data-v-67108e77]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:0;font-size:20px;font-weight:600;color:#303133;line-height:1.4\n}\n.training-instruction-sub-heading__title-text[data-v-67108e77]{min-width:0\n}\n.training-instruction-sub-heading__id-badge[data-v-67108e77]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-negative:0;flex-shrink:0;padding:2px 8px;border-radius:4px;font-size:12px;font-weight:500;line-height:20px;color:#606266;background:#f4f4f5;border:1px solid #e9e9eb;font-variant-numeric:tabular-nums\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1668:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"training-instruction-sub-heading"},[_c('el-button',{staticClass:"training-instruction-sub-heading__back",attrs:{"icon":"el-icon-arrow-left","circle":""},on:{"click":_vm.onBack}}),_vm._v(" "),_c('h2',{staticClass:"training-instruction-sub-heading__title"},[_c('span',{staticClass:"training-instruction-sub-heading__title-text"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.hasEntityId)?_c('span',{staticClass:"training-instruction-sub-heading__id-badge"},[_vm._v("ID："+_vm._s(_vm.entityId))]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1706:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_utils_table_column_config__ = __webpack_require__(1606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_components_TableColumnConfigDialog_vue__ = __webpack_require__(1800);



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TableColumnConfigDialog: __WEBPACK_IMPORTED_MODULE_1__core_components_TableColumnConfigDialog_vue__["a" /* default */]
  },
  data: function data() {
    return {
      tableColumnConfigDialogVisible: false,
      tableColumnAppliedConfig: [],
      tableColumnRenderKey: 0
    };
  },
  created: function created() {
    this.initTableColumnConfig();
  },

  computed: {
    activeTableColumns: function activeTableColumns() {
      var _this = this;

      var columns = Object(__WEBPACK_IMPORTED_MODULE_0__core_utils_table_column_config__["d" /* resolveVisibleColumns */])(this.getTableColumnDefinitions(), this.tableColumnAppliedConfig);
      return columns.filter(function (column) {
        return _this.isTableColumnContextVisible(column);
      });
    }
  },
  methods: {
    getTableColumnDefinitions: function getTableColumnDefinitions() {
      return this.fields || [];
    },
    getTableColumnStorageKey: function getTableColumnStorageKey() {
      return '';
    },
    isTableColumnContextVisible: function isTableColumnContextVisible(column) {
      if (!column.visibleWhen) {
        return true;
      }
      if (typeof column.visibleWhen === 'function') {
        return column.visibleWhen.call(this);
      }
      if (typeof column.visibleWhen === 'string') {
        return !!this[column.visibleWhen];
      }
      return true;
    },
    initTableColumnConfig: function initTableColumnConfig() {
      var definitions = this.getTableColumnDefinitions();
      var saved = Object(__WEBPACK_IMPORTED_MODULE_0__core_utils_table_column_config__["b" /* loadColumnConfig */])(this.getTableColumnStorageKey());
      this.tableColumnAppliedConfig = Object(__WEBPACK_IMPORTED_MODULE_0__core_utils_table_column_config__["c" /* normalizeColumnConfig */])(definitions, saved);
    },
    openTableColumnConfigDialog: function openTableColumnConfigDialog() {
      this.tableColumnConfigDialogVisible = true;
    },
    onTableColumnConfigSave: function onTableColumnConfigSave(draft) {
      this.tableColumnAppliedConfig = _.cloneDeep(draft);
      Object(__WEBPACK_IMPORTED_MODULE_0__core_utils_table_column_config__["e" /* saveColumnConfig */])(this.getTableColumnStorageKey(), {
        columns: this.tableColumnAppliedConfig
      });
      this.tableColumnRenderKey += 1;
      this.$message.success('列配置已保存');
    }
  }
});

/***/ }),

/***/ 1800:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableColumnConfigDialog_vue__ = __webpack_require__(1607);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f7827dc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableColumnConfigDialog_vue__ = __webpack_require__(1805);
function injectStyle (ssrContext) {
  __webpack_require__(1801)
  __webpack_require__(1803)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f7827dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableColumnConfigDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f7827dc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableColumnConfigDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1801:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1802);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("16fd6716", content, true, {});

/***/ }),

/***/ 1802:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".table-column-config-dialog__tip[data-v-7f7827dc]{margin:0 0 12px;color:#909399;font-size:13px;line-height:1.6}.table-column-config-dialog__body[data-v-7f7827dc]{max-height:420px;overflow-y:auto;padding-right:4px}.table-column-config-dialog__list[data-v-7f7827dc],.table-column-config-dialog__locked-list[data-v-7f7827dc]{display:block}.table-column-config-dialog__item[data-v-7f7827dc]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:10px;padding:10px 12px;margin-bottom:8px;border:1px solid #ebeef5;border-radius:8px;background:#fafbfc}.table-column-config-dialog__item.is-locked[data-v-7f7827dc]{background:#f5f7fa}.table-column-config-dialog__item-ghost[data-v-7f7827dc]{opacity:.6;background:#ecf5ff}.table-column-config-dialog__locked-list[data-v-7f7827dc]{margin-top:4px;padding-top:8px;border-top:1px dashed #ebeef5}.table-column-config-dialog__drag-handle[data-v-7f7827dc]{color:#c0c4cc;cursor:move;font-size:16px;-ms-flex-negative:0;flex-shrink:0}.table-column-config-dialog__drag-placeholder[data-v-7f7827dc]{width:16px;-ms-flex-negative:0;flex-shrink:0}.table-column-config-dialog__locked-tag[data-v-7f7827dc]{margin-left:auto;color:#909399;font-size:12px}", "", {"version":3,"sources":["/workspace/core/components/TableColumnConfigDialog.vue"],"names":[],"mappings":"AACA,kDAAkD,gBAAgB,cAAc,eAAe,eAAe,CAC7G,AACD,mDAAmD,iBAAiB,gBAAgB,iBAAiB,CACpG,AACD,6GAA6G,aAAa,CACzH,AACD,mDAAmD,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,SAAS,kBAAkB,kBAAkB,yBAAyB,kBAAkB,kBAAkB,CACnR,AACD,6DAA6D,kBAAkB,CAC9E,AACD,yDAAyD,WAAY,kBAAkB,CACtF,AACD,0DAA0D,eAAe,gBAAgB,6BAA6B,CACrH,AACD,0DAA0D,cAAc,YAAY,eAAe,oBAAoB,aAAa,CACnI,AACD,+DAA+D,WAAW,oBAAoB,aAAa,CAC1G,AACD,yDAAyD,iBAAiB,cAAc,cAAc,CACrG","file":"TableColumnConfigDialog.vue","sourcesContent":["\n.table-column-config-dialog__tip[data-v-7f7827dc]{margin:0 0 12px;color:#909399;font-size:13px;line-height:1.6\n}\n.table-column-config-dialog__body[data-v-7f7827dc]{max-height:420px;overflow-y:auto;padding-right:4px\n}\n.table-column-config-dialog__list[data-v-7f7827dc],.table-column-config-dialog__locked-list[data-v-7f7827dc]{display:block\n}\n.table-column-config-dialog__item[data-v-7f7827dc]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:10px;padding:10px 12px;margin-bottom:8px;border:1px solid #ebeef5;border-radius:8px;background:#fafbfc\n}\n.table-column-config-dialog__item.is-locked[data-v-7f7827dc]{background:#f5f7fa\n}\n.table-column-config-dialog__item-ghost[data-v-7f7827dc]{opacity:0.6;background:#ecf5ff\n}\n.table-column-config-dialog__locked-list[data-v-7f7827dc]{margin-top:4px;padding-top:8px;border-top:1px dashed #ebeef5\n}\n.table-column-config-dialog__drag-handle[data-v-7f7827dc]{color:#c0c4cc;cursor:move;font-size:16px;-ms-flex-negative:0;flex-shrink:0\n}\n.table-column-config-dialog__drag-placeholder[data-v-7f7827dc]{width:16px;-ms-flex-negative:0;flex-shrink:0\n}\n.table-column-config-dialog__locked-tag[data-v-7f7827dc]{margin-left:auto;color:#909399;font-size:12px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1803:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1804);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("13d04a60", content, true, {});

/***/ }),

/***/ 1804:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".table-column-config-dialog .el-dialog__body{padding-top:12px;padding-bottom:12px}", "", {"version":3,"sources":["/workspace/core/components/TableColumnConfigDialog.vue"],"names":[],"mappings":"AACA,6CAA6C,iBAAiB,mBAAmB,CAChF","file":"TableColumnConfigDialog.vue","sourcesContent":["\n.table-column-config-dialog .el-dialog__body{padding-top:12px;padding-bottom:12px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1805:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"列配置","width":"520px","visible":_vm.dialogVisible,"close-on-click-modal":false,"append-to-body":"","custom-class":"table-column-config-dialog"},on:{"update:visible":function($event){_vm.dialogVisible=$event},"closed":_vm.onClosed}},[_c('p',{staticClass:"table-column-config-dialog__tip"},[_vm._v("拖拽调整列顺序，勾选控制列显示。保存后生效，取消则不修改。")]),_vm._v(" "),_c('div',{staticClass:"table-column-config-dialog__body"},[_c('draggable',{staticClass:"table-column-config-dialog__list",attrs:{"tag":"div","handle":".table-column-config-dialog__drag-handle","animation":200,"ghost-class":"table-column-config-dialog__item-ghost"},model:{value:(_vm.sortableDraft),callback:function ($$v) {_vm.sortableDraft=$$v},expression:"sortableDraft"}},_vm._l((_vm.sortableDraft),function(item){return _c('div',{key:item.key,staticClass:"table-column-config-dialog__item"},[_c('i',{staticClass:"el-icon-rank table-column-config-dialog__drag-handle"}),_vm._v(" "),_c('el-checkbox',{attrs:{"disabled":item.locked},model:{value:(item.visible),callback:function ($$v) {_vm.$set(item, "visible", $$v)},expression:"item.visible"}},[_vm._v("\n          "+_vm._s(item.label)+"\n        ")])],1)}),0),_vm._v(" "),(_vm.lockedDraft.length)?_c('div',{staticClass:"table-column-config-dialog__locked-list"},_vm._l((_vm.lockedDraft),function(item){return _c('div',{key:item.key,staticClass:"table-column-config-dialog__item is-locked"},[_c('span',{staticClass:"table-column-config-dialog__drag-placeholder"}),_vm._v(" "),_c('el-checkbox',{attrs:{"disabled":""},model:{value:(item.visible),callback:function ($$v) {_vm.$set(item, "visible", $$v)},expression:"item.visible"}},[_vm._v("\n          "+_vm._s(item.label)+"\n        ")]),_vm._v(" "),_c('span',{staticClass:"table-column-config-dialog__locked-tag"},[_vm._v("固定")])],1)}),0):_vm._e()],1),_vm._v(" "),_c('template',{slot:"footer"},[_c('el-button',{on:{"click":_vm.onReset}},[_vm._v("恢复默认")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.onCancel}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onSave}},[_vm._v("保存")])],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1806:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return consts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return opts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TRAINING_INSTRUCTION_RECORD_TABLE_COLUMN_STORAGE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRAINING_INSTRUCTION_EXAM_RECORD_TABLE_COLUMN_STORAGE_KEY; });
var consts = {
  SOURCE_TYPE_TASK: 1,
  SOURCE_TYPE_LEARNING_CENTER: 2,
  SOURCE_TYPE_ASSIGN: 3,

  STATUS_LEARNING: 1,
  STATUS_LEARN_FINISHED: 2,
  STATUS_WAIT_EXAM: 3,
  STATUS_ON_EXAM: 4,
  STATUS_PASSED: 5,
  STATUS_EXAM_NOT_PASS: 6,
  STATUS_EXAM_WAIT_RETRY: 7,

  EXAMINATION_STATUS_NOT_START: 0,
  EXAMINATION_STATUS_WAIT_SUBMIT: 1,
  EXAMINATION_STATUS_PASS: 2,
  EXAMINATION_STATUS_NOT_PASS: 3,
  EXAMINATION_STATUS_SUBMITTED: 4
};

var opts = {
  sourceTypeMaps: [{ value: consts.SOURCE_TYPE_TASK, label: '批次任务' }, { value: consts.SOURCE_TYPE_LEARNING_CENTER, label: '学习中心' }, { value: consts.SOURCE_TYPE_ASSIGN, label: '管理员分配' }],
  recordStatusMaps: [{ value: consts.STATUS_LEARNING, label: '学习中' }, { value: consts.STATUS_LEARN_FINISHED, label: '已学完' }, { value: consts.STATUS_WAIT_EXAM, label: '待考试' }, { value: consts.STATUS_ON_EXAM, label: '考试中' }, { value: consts.STATUS_PASSED, label: '通过' }, { value: consts.STATUS_EXAM_NOT_PASS, label: '考试未通过' }, { value: consts.STATUS_EXAM_WAIT_RETRY, label: '待重考' }],
  examinationStatusMaps: [{ value: consts.EXAMINATION_STATUS_NOT_START, label: '未开始' }, { value: consts.EXAMINATION_STATUS_WAIT_SUBMIT, label: '待提交' }, { value: consts.EXAMINATION_STATUS_PASS, label: '通过' }, { value: consts.EXAMINATION_STATUS_NOT_PASS, label: '不通过' }, { value: consts.EXAMINATION_STATUS_SUBMITTED, label: '已提交' }]
};

var TRAINING_INSTRUCTION_RECORD_TABLE_COLUMN_STORAGE_KEY = 'training-instruction-record-list';
var TRAINING_INSTRUCTION_EXAM_RECORD_TABLE_COLUMN_STORAGE_KEY = 'training-instruction-exam-record-list';

/***/ }),

/***/ 1830:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return consts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return opts; });
/* harmony export (immutable) */ __webpack_exports__["i"] = getOptionLabel;
/* harmony export (immutable) */ __webpack_exports__["f"] = getExamStatusLabel;
/* harmony export (immutable) */ __webpack_exports__["g"] = getExamStatusType;
/* harmony export (immutable) */ __webpack_exports__["e"] = getExamStatusActions;
/* harmony export (immutable) */ __webpack_exports__["o"] = isExamStructureLocked;
/* harmony export (immutable) */ __webpack_exports__["l"] = isExamReadonly;
/* harmony export (immutable) */ __webpack_exports__["m"] = isExamScopeLocked;
/* harmony export (immutable) */ __webpack_exports__["n"] = isExamScoreLocked;
/* harmony export (immutable) */ __webpack_exports__["j"] = isExamAnswerLocked;
/* harmony export (immutable) */ __webpack_exports__["k"] = isExamOptionStructureLocked;
/* unused harmony export createExamQuestionClientId */
/* harmony export (immutable) */ __webpack_exports__["c"] = createExamQuestion;
/* harmony export (immutable) */ __webpack_exports__["p"] = normalizeExamQuestionFromRow;
/* unused harmony export getExamQuestionSubmitPayload */
/* harmony export (immutable) */ __webpack_exports__["h"] = getExamSubmitPayload;
/* unused harmony export TRAINING_EXAM_COPY_TYPE */
/* harmony export (immutable) */ __webpack_exports__["a"] = buildTrainingExamCopyData;
/* harmony export (immutable) */ __webpack_exports__["q"] = normalizeTrainingExamCopyData;
/* harmony export (immutable) */ __webpack_exports__["d"] = getExamQuestionDuplicateKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_training_training_course_constants__ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__ = __webpack_require__(1526);






var consts = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__views_training_training_course_constants__["b" /* consts */], {
  OPEN_BOOK_EXAM_OPEN: 1,
  OPEN_BOOK_EXAM_CLOSED: 2,
  SORT_TYPE_FIXED: 1,
  SORT_TYPE_RANDOM: 2
});

var opts = {
  targetUserMaps: __WEBPACK_IMPORTED_MODULE_3__views_training_training_course_constants__["i" /* opts */].targetUserMaps,
  isCommonMaps: __WEBPACK_IMPORTED_MODULE_3__views_training_training_course_constants__["i" /* opts */].isCommonMaps,
  statusMaps: __WEBPACK_IMPORTED_MODULE_3__views_training_training_course_constants__["i" /* opts */].statusMaps,
  openBookMaps: [{ value: consts.OPEN_BOOK_EXAM_OPEN, label: '开卷' }, { value: consts.OPEN_BOOK_EXAM_CLOSED, label: '闭卷' }],
  sortTypeMaps: [{ value: consts.SORT_TYPE_FIXED, label: '固定顺序' }, { value: consts.SORT_TYPE_RANDOM, label: '乱序' }]
};

function getOptionLabel(options, value) {
  var item = options.find(function (option) {
    return Number(option.value) === Number(value);
  });
  return item ? item.label : '';
}

function getExamStatusLabel(status) {
  return getOptionLabel(opts.statusMaps, status) || '未知状态';
}

function getExamStatusType(status) {
  switch (Number(status)) {
    case consts.STATUS_ONLINE:
      return 'success';
    case consts.STATUS_OFFLINE:
      return 'warning';
    case consts.STATUS_BANNED:
      return 'danger';
    default:
      return 'info';
  }
}

function getExamStatusActions(status) {
  switch (Number(status)) {
    case consts.STATUS_NEW:
      return [{ name: 'online', label: '上架', type: 'success', apiName: 'onlineTrainingExamination', successText: '上架成功' }];
    case consts.STATUS_ONLINE:
      return [{
        name: 'offline',
        label: '下架',
        type: 'warning',
        apiName: 'offlineTrainingExamination',
        successText: '下架成功'
      }];
    case consts.STATUS_OFFLINE:
      return [{ name: 'ban', label: '作废', type: 'danger', apiName: 'banTrainingExamination', successText: '作废成功' }, { name: 'online', label: '上架', type: 'success', apiName: 'onlineTrainingExamination', successText: '上架成功' }];
    case consts.STATUS_BANNED:
      return [{ name: 'active', label: '激活', type: 'primary', apiName: 'activeTrainingExamination', successText: '激活成功' }];
    default:
      return [];
  }
}

function isExamStructureLocked(status) {
  return Number(status) === consts.STATUS_ONLINE || Number(status) === consts.STATUS_BANNED;
}

function isExamReadonly(status) {
  return Number(status) === consts.STATUS_BANNED;
}

function isExamScopeLocked(status) {
  return Number(status) === consts.STATUS_ONLINE || Number(status) === consts.STATUS_OFFLINE || Number(status) === consts.STATUS_BANNED;
}

function isExamScoreLocked(status) {
  return Number(status) !== consts.STATUS_NEW;
}

function isExamAnswerLocked(status) {
  return Number(status) === consts.STATUS_ONLINE || Number(status) === consts.STATUS_BANNED;
}

function isExamOptionStructureLocked(status) {
  return Number(status) === consts.STATUS_ONLINE || Number(status) === consts.STATUS_BANNED;
}

function createExamQuestionClientId() {
  return 'examq' + Math.random().toString(16).slice(2) + Date.now();
}

function createExamQuestion() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_SINGLE;
  var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var questionType = Number(type) || __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_SINGLE;
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
    client_id: createExamQuestionClientId(),
    source_question_id: null,
    target_usertype: null,
    customerid: null,
    training_knowledge_id: null,
    question_type: questionType,
    title: '',
    sample_files: [],
    options: Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["k" /* isChoiceQuestion */])(questionType) ? Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["c" /* createDefaultQuestionOptions */])() : [],
    standard_answer: Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["p" /* resetQuestionAnswerByType */])(questionType),
    analysis_text: '',
    analysis_files: []
  }, overrides);
}

function hasValue(value) {
  return value !== undefined && value !== null && value !== '';
}

// 格式化每个题目，扁平化，原因是题目组件当时重新组装了form，这里复用组件也需要重新组装一下后端或者粘贴的题目结构
function normalizeExamQuestionFromRow(row) {
  var questionJson = row.question_json || {};
  var analysis = questionJson.question_analysis || {};
  var questionType = Number(row.question_type) || __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_SINGLE;
  var standardAnswer = hasValue(questionJson.standard_answer) ? questionJson.standard_answer : row.standard_answer;

  return createExamQuestion(questionType, {
    title: row.title || questionJson.title || '',
    source_question_id: row.id || null,
    target_usertype: hasValue(row.target_usertype) ? row.target_usertype : null,
    customerid: hasValue(row.customerid) ? row.customerid : null,
    training_knowledge_id: hasValue(row.training_knowledge_id) ? row.training_knowledge_id : null,
    sample_files: Array.isArray(questionJson.sample_files) ? questionJson.sample_files : [],
    options: Array.isArray(questionJson.options) ? questionJson.options : [],
    standard_answer: hasValue(standardAnswer) ? standardAnswer : Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["p" /* resetQuestionAnswerByType */])(questionType),
    analysis_text: analysis.analysis_text || '',
    analysis_files: Array.isArray(analysis.analysis_files) ? analysis.analysis_files : []
  });
}

// 格式化每道题目，如果后续没有改动可以复用training-question.constants-getQuestionSubmitPayload方法，先这样各自处理吧
function getExamQuestionSubmitPayload(question) {
  var questionType = Number(question.question_type);
  var questionJson = {
    title: question.title || '',
    sample_files: question.sample_files || [],
    question_analysis: {
      analysis_text: question.analysis_text || '',
      analysis_files: question.analysis_files || []
    },
    standard_answer: question.standard_answer
  };

  if (Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["k" /* isChoiceQuestion */])(questionType)) {
    questionJson.options = question.options || [];
  }

  return {
    id: question.source_question_id || question.id || null,
    question_type: questionType,
    question_json: questionJson
  };
}

function getExamSubmitPayload(form) {
  return {
    title: form.title,
    target_usertype: String(form.target_usertype),
    is_common: Number(form.is_common),
    customerid: Number(form.customerid) || 0,
    training_knowledge_id: Number(form.training_knowledge_id),
    open_book_exam: Number(form.open_book_exam),
    question_score: Number(form.question_score),
    passing_score: Number(form.passing_score),
    exam_duration: Number(form.exam_duration),
    question_sort_type: Number(form.question_sort_type),
    question_options_sort_type: Number(form.question_options_sort_type),
    question_list: (form.question_list || []).map(function (question) {
      return getExamQuestionSubmitPayload(question);
    })
  };
}

var TRAINING_EXAM_COPY_TYPE = 'training-exam';

function buildTrainingExamCopyData(form) {
  var data = getExamSubmitPayload(form);
  return {
    version: 1,
    date: new Date().toISOString(),
    type: TRAINING_EXAM_COPY_TYPE,
    title: data.title,
    data: data
  };
}

function normalizeTrainingExamCopyData(copyData) {
  if (!copyData || copyData.type !== TRAINING_EXAM_COPY_TYPE || !copyData.data) {
    return null;
  }

  var data = copyData.data;
  return {
    title: data.title || '',
    target_usertype: Number(data.target_usertype) || consts.TARGETUSER_TYPE_USER,
    is_common: Number(data.is_common || consts.IS_COMMON_DEDICATED),
    customerid: Number(data.customerid) > 0 ? String(data.customerid) : null,
    training_knowledge_id: data.training_knowledge_id || null,
    open_book_exam: Number(data.open_book_exam) || consts.OPEN_BOOK_EXAM_CLOSED,
    question_score: Number(data.question_score) || 10,
    passing_score: Number(data.passing_score) || 60,
    exam_duration: Number(data.exam_duration) || 60,
    question_sort_type: Number(data.question_sort_type) || consts.SORT_TYPE_FIXED,
    question_options_sort_type: Number(data.question_options_sort_type) || consts.SORT_TYPE_FIXED,
    question_list: Array.isArray(data.question_list) ? data.question_list.map(function (item) {
      return normalizeExamQuestionFromRow(item);
    }) : []
  };
}

// 不做前端验证，代码先保留 重复项检查比对的是选项显示的内容，而不是内部的选项 UUID
function getChoiceAnswerIndex(answer, options) {
  return options.findIndex(function (option) {
    return option.uuid === answer;
  });
}

function getChoiceDuplicateAnswer(questionType, questionJson, options) {
  if (Number(questionType) === __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_MULTI) {
    return (Array.isArray(questionJson.standard_answer) ? questionJson.standard_answer : []).map(function (answer) {
      return getChoiceAnswerIndex(answer, options);
    }).sort(function (prev, next) {
      return prev - next;
    });
  }
  return getChoiceAnswerIndex(questionJson.standard_answer, options);
}

function getExamQuestionDuplicateKey(question) {
  var payload = getExamQuestionSubmitPayload(question);
  var questionJson = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, payload.question_json);

  if (Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["k" /* isChoiceQuestion */])(payload.question_type)) {
    var options = Array.isArray(questionJson.options) ? questionJson.options : [];
    // 取标题检测
    questionJson.options = options.map(function (option) {
      return {
        title: option.title || ''
      };
    });
    questionJson.standard_answer = getChoiceDuplicateAnswer(payload.question_type, questionJson, options);
  }

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
    question_type: payload.question_type,
    question_json: questionJson
  });
}

/***/ }),

/***/ 3045:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_mixins_table_v3__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_mixins_dateTimePicker__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_mixins_table_column_config__ = __webpack_require__(1706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_training_training_instruction_record_constants__ = __webpack_require__(1806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_training_training_instruction_record_table_fields__ = __webpack_require__(5630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_training_training_instruction_constants__ = __webpack_require__(1665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_training_training_exam_constants__ = __webpack_require__(1830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_training_components_TrainingInstructionSubHeading_vue__ = __webpack_require__(1612);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var FIELD_COLUMN_BIND_KEYS = ['prop', 'label', 'width', 'minWidth', 'showOverflowTooltip', 'fixed', 'align'];

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TrainingInstructionSubHeading: __WEBPACK_IMPORTED_MODULE_11__views_training_components_TrainingInstructionSubHeading_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__core_mixins_table_v3__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__core_mixins_dateTimePicker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__core_mixins_table_column_config__["a" /* default */]],
  data: function data() {
    var _this = this;

    return {
      searchExpanded: true,
      listExpanded: true,
      opts: __WEBPACK_IMPORTED_MODULE_7__views_training_training_instruction_record_constants__["d" /* opts */],
      consts: __WEBPACK_IMPORTED_MODULE_7__views_training_training_instruction_record_constants__["c" /* consts */],
      targetUserMaps: __WEBPACK_IMPORTED_MODULE_9__views_training_training_instruction_constants__["c" /* opts */].targetUserMaps,
      chinaAreaData: [],
      instruction: {
        id: this.$route.params.id,
        title: this.$route.query.title || '',
        passingScore: 60
      },
      search: {
        keyword: '',
        instruction_record_status: null,
        target_usertype: null,
        source_type: null,
        projectid: null,
        batchid: null,
        regionids: [],
        learning_finished_at: [],
        examination_submitted_at: []
      },
      searchFieldType: {
        instruction_record_status: Number,
        target_usertype: Number,
        source_type: Number,
        projectid: Number,
        batchid: Number,
        regionids: Array,
        learning_finished_at: Array,
        examination_submitted_at: Array
      },
      exportHeader: [{ key: 'id', text: '记录ID' }, { key: 'training_instruction_title', text: '培训标题' }, { key: 'userid', text: '用户ID' }, { key: 'realname', text: '真实姓名' }, { key: 'region_name', text: '省市区' }, { key: 'target_usertype_name', text: '用户类型' }, { key: 'source_type_name', text: '来源' }, { key: 'project_name', text: '项目' }, { key: 'batch_name', text: '批次' }, { key: 'task_title', text: '任务' }, { key: 'instruction_record_status_name', text: '培训状态' }, {
        key: 'learning_progress',
        text: '学习进度',
        formatter: function formatter(row) {
          return _this.hasLearningProgress(row) ? _this.getLearningProgress(row) + '%' : '-';
        }
      }, {
        key: 'examination_score',
        text: '考试分数',
        formatter: function formatter(row) {
          return _this.hasExaminationScore(row) ? row.examination_score + '\u5206' : '-';
        }
      }, { key: 'learning_started_at', text: '开始学习时间' }, { key: 'learning_finished_at', text: '完成学习时间' }, { key: 'examination_submitted_at', text: '考试提交时间' }],
      fields: Object(__WEBPACK_IMPORTED_MODULE_8__views_training_training_instruction_record_table_fields__["a" /* createTrainingInstructionRecordTableFields */])(this)
    };
  },

  computed: {
    pageHeadingTitle: function pageHeadingTitle() {
      var title = this.instruction.title || this.$route.query.title;
      return title ? '\u7528\u6237\u57F9\u8BAD\u8BB0\u5F55 \xB7 ' + title : '用户培训记录';
    },
    pageTitle: function pageTitle() {
      return this.pageHeadingTitle + ' ID\uFF1A' + this.instruction.id;
    },
    activeTableFields: function activeTableFields() {
      var fieldMap = _.keyBy(this.fields, 'key');
      return this.activeTableColumns.map(function (column) {
        return fieldMap[column.key];
      }).filter(Boolean);
    }
  },
  created: function created() {
    this.loadInstruction();
    this.getChinaAreaData();
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    getTableColumnStorageKey: function getTableColumnStorageKey() {
      return __WEBPACK_IMPORTED_MODULE_7__views_training_training_instruction_record_constants__["b" /* TRAINING_INSTRUCTION_RECORD_TABLE_COLUMN_STORAGE_KEY */];
    },
    getFieldColumnBind: function getFieldColumnBind(field) {
      return _.pick(field, FIELD_COLUMN_BIND_KEYS);
    }
  }, request.map(['getProjectTable', 'getProjectDetail', 'getBatchTable', 'getBatchDetail']), {
    loadInstruction: function loadInstruction() {
      var _this2 = this;

      request.common('getTrainingInstruction', { id: this.instruction.id }).then(function (_ref) {
        var data = _ref.data;

        _this2.instruction.title = data.title;
        var examinationJson = data.training_examination_json || {};
        if (examinationJson.passing_score) {
          _this2.instruction.passingScore = Number(examinationJson.passing_score);
        }
      }).catch(function () {});
    },
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;

      return __WEBPACK_IMPORTED_MODULE_4__core_mixins_table_v3__["a" /* default */].methods.getRouterQueryParams.call(this, query);
    },
    getTableData: function getTableData(params) {
      delete params.id;
      delete params.title;
      delete params.recordId;
      params.training_instruction_id = this.instruction.id;
      params.record_list_type = 'learning';
      return request.page('queryTrainingInstructionRecord', params);
    },
    resetSearch: function resetSearch() {
      this.$refs.searchForm.resetFields();
      this.onSearch();
    },
    getChinaAreaData: function getChinaAreaData() {
      var _this3 = this;

      request.alert('queryAllFormatted').then(function (_ref2) {
        var data = _ref2.data;

        _this3.chinaAreaData = Array.isArray(data) ? data : Array.isArray(data && data.data) ? data.data : [];
      }).catch(function () {
        _this3.chinaAreaData = [];
      });
    },
    isOpenBookExamRow: function isOpenBookExamRow(row) {
      return Number(row.open_book_exam) === __WEBPACK_IMPORTED_MODULE_10__views_training_training_exam_constants__["b" /* consts */].OPEN_BOOK_EXAM_OPEN;
    },
    hasExaminationScore: function hasExaminationScore(row) {
      return Number(row.examination_status) > __WEBPACK_IMPORTED_MODULE_7__views_training_training_instruction_record_constants__["c" /* consts */].EXAMINATION_STATUS_NOT_START;
    },
    canViewExamDetail: function canViewExamDetail(row) {
      return Number(row.examination_status) > __WEBPACK_IMPORTED_MODULE_7__views_training_training_instruction_record_constants__["c" /* consts */].EXAMINATION_STATUS_NOT_START;
    },
    getExamDetailLink: function getExamDetailLink(row) {
      return {
        path: '/training/instruction/exam-records/' + this.instruction.id + '/detail/' + row.id,
        query: { title: this.instruction.title }
      };
    },
    hasLearningProgress: function hasLearningProgress(row) {
      return row.learning_progress !== null && row.learning_progress !== undefined && row.learning_progress !== '';
    },
    getLearningProgress: function getLearningProgress(row) {
      if (!this.hasLearningProgress(row)) {
        return null;
      }
      var progress = Number(row.learning_progress);
      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default()(progress)) {
        return 0;
      }
      return Math.min(100, Math.max(0, progress));
    },
    isLearningCenterSource: function isLearningCenterSource(row) {
      return Number(row.source_type) === __WEBPACK_IMPORTED_MODULE_7__views_training_training_instruction_record_constants__["c" /* consts */].SOURCE_TYPE_LEARNING_CENTER;
    },
    getUserTypeTagClass: function getUserTypeTagClass(value) {
      var type = Number(value);
      if (type === __WEBPACK_IMPORTED_MODULE_9__views_training_training_instruction_constants__["b" /* consts */].TARGETUSER_TYPE_INTERN) {
        return 'is-intern';
      }
      if (type === __WEBPACK_IMPORTED_MODULE_9__views_training_training_instruction_constants__["b" /* consts */].TARGETUSER_TYPE_USER) {
        return 'is-worker';
      }
      return 'is-default';
    },
    getSourceTypeTagClass: function getSourceTypeTagClass(value) {
      var _map;

      var map = (_map = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_map, __WEBPACK_IMPORTED_MODULE_7__views_training_training_instruction_record_constants__["c" /* consts */].SOURCE_TYPE_TASK, 'is-task'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_map, __WEBPACK_IMPORTED_MODULE_7__views_training_training_instruction_record_constants__["c" /* consts */].SOURCE_TYPE_LEARNING_CENTER, 'is-learning-center'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_map, __WEBPACK_IMPORTED_MODULE_7__views_training_training_instruction_record_constants__["c" /* consts */].SOURCE_TYPE_ASSIGN, 'is-assign'), _map);
      return map[Number(value)] || 'is-default';
    },
    getRecordStatusTagClass: function getRecordStatusTagClass(value) {
      var _map2;

      var map = (_map2 = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_map2, __WEBPACK_IMPORTED_MODULE_7__views_training_training_instruction_record_constants__["c" /* consts */].STATUS_LEARNING, 'is-learning'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_map2, __WEBPACK_IMPORTED_MODULE_7__views_training_training_instruction_record_constants__["c" /* consts */].STATUS_LEARN_FINISHED, 'is-learned'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_map2, __WEBPACK_IMPORTED_MODULE_7__views_training_training_instruction_record_constants__["c" /* consts */].STATUS_WAIT_EXAM, 'is-wait-exam'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_map2, __WEBPACK_IMPORTED_MODULE_7__views_training_training_instruction_record_constants__["c" /* consts */].STATUS_ON_EXAM, 'is-examining'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_map2, __WEBPACK_IMPORTED_MODULE_7__views_training_training_instruction_record_constants__["c" /* consts */].STATUS_PASSED, 'is-passed'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_map2, __WEBPACK_IMPORTED_MODULE_7__views_training_training_instruction_record_constants__["c" /* consts */].STATUS_EXAM_NOT_PASS, 'is-failed'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_map2, __WEBPACK_IMPORTED_MODULE_7__views_training_training_instruction_record_constants__["c" /* consts */].STATUS_EXAM_WAIT_RETRY, 'is-retry'), _map2);
      return map[Number(value)] || 'is-default';
    },
    getExamScoreClass: function getExamScoreClass(row) {
      var score = Number(row.examination_score);
      if (Number(row.examination_status) === __WEBPACK_IMPORTED_MODULE_7__views_training_training_instruction_record_constants__["c" /* consts */].EXAMINATION_STATUS_PASS) {
        return 'is-pass';
      }
      if (Number(row.examination_status) === __WEBPACK_IMPORTED_MODULE_7__views_training_training_instruction_record_constants__["c" /* consts */].EXAMINATION_STATUS_NOT_PASS) {
        return 'is-fail';
      }
      return score >= this.instruction.passingScore ? 'is-pass' : 'is-fail';
    },
    onExport: function onExport() {
      var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.search, {
        training_instruction_id: this.instruction.id
      });
      this.$export(this.pageTitle, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: params
      });
    }
  })
});

/***/ }),

/***/ 5626:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5627);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("040d646e", content, true, {});

/***/ }),

/***/ 5627:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".training-instruction-record__card[data-v-50e74cef]{background:#fff;border-radius:8px;-webkit-box-shadow:0 1px 3px rgba(0,0,0,.08);box-shadow:0 1px 3px rgba(0,0,0,.08);overflow:hidden}.training-instruction-record__card+.training-instruction-record__card[data-v-50e74cef]{margin-top:16px}.training-instruction-record__card-header[data-v-50e74cef]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:12px 24px;border-bottom:1px solid #ebeef5;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:#606266;font-size:14px;font-weight:500}.training-instruction-record__card-header i[data-v-50e74cef]{color:#909399}.training-instruction-record__card-header-actions[data-v-50e74cef]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px}.training-instruction-record__card-header-actions ::v-deep .training-instruction-record__header-action.el-button[data-v-50e74cef]{min-width:24px;padding:0;margin:0}.training-instruction-record__header-action[data-v-50e74cef]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:24px;height:24px;padding:0;margin:0;color:#909399;-ms-flex-negative:0;flex-shrink:0;line-height:1}.training-instruction-record__header-action i[data-v-50e74cef]{font-size:14px}.training-instruction-record__search-form[data-v-50e74cef]{padding:16px 24px 20px}.training-instruction-record__search-grid[data-v-50e74cef]{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px 16px}.training-instruction-record__search-actions[data-v-50e74cef]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:12px;margin-top:4px;padding-top:4px}.training-instruction-record__list-body[data-v-50e74cef]{padding:0 16px 16px}.training-instruction-record__table-wrap[data-v-50e74cef]{border:1px solid #ebeef5;border-radius:8px;overflow:hidden}.training-instruction-record__table ::v-deep th[data-v-50e74cef]{background:#f5f7fa;color:#909399;font-size:12px;font-weight:500}.training-instruction-record__table ::v-deep td[data-v-50e74cef]{font-size:14px;color:#303133}.training-instruction-record__table ::v-deep .el-table__row:hover>td[data-v-50e74cef]{background:#fafafa}.training-instruction-record__table[data-v-50e74cef] ::v-deep:before{display:none}.training-instruction-record__tag[data-v-50e74cef]{display:inline-block;padding:2px 10px;border-radius:999px;font-size:12px;line-height:20px;font-weight:500;white-space:nowrap}.training-instruction-record__tag.is-worker[data-v-50e74cef]{background:#dbeafe;color:#1d4ed8}.training-instruction-record__tag.is-intern[data-v-50e74cef]{background:#ede9fe;color:#6d28d9}.training-instruction-record__tag.is-task[data-v-50e74cef]{background:#e0e7ff;color:#4338ca}.training-instruction-record__tag.is-learning-center[data-v-50e74cef]{background:#cffafe;color:#0e7490}.training-instruction-record__tag.is-assign[data-v-50e74cef]{background:#f3e8ff;color:#7e22ce}.training-instruction-record__tag.is-learning[data-v-50e74cef]{background:#dbeafe;color:#1d4ed8}.training-instruction-record__tag.is-learned[data-v-50e74cef]{background:#dcfce7;color:#15803d}.training-instruction-record__tag.is-wait-exam[data-v-50e74cef]{background:#fef9c3;color:#a16207}.training-instruction-record__tag.is-examining[data-v-50e74cef]{background:#ffedd5;color:#c2410c}.training-instruction-record__tag.is-passed[data-v-50e74cef]{background:#d1fae5;color:#047857}.training-instruction-record__tag.is-failed[data-v-50e74cef],.training-instruction-record__tag.is-retry[data-v-50e74cef]{background:#fee2e2;color:#dc2626}.training-instruction-record__tag.is-default[data-v-50e74cef]{background:#f3f4f6;color:#6b7280}.training-instruction-record__sub-id[data-v-50e74cef]{margin-left:4px;color:#c0c4cc;font-size:12px;font-family:Menlo,Monaco,Consolas,monospace}.training-instruction-record__empty[data-v-50e74cef]{color:#c0c4cc}.training-instruction-record__progress[data-v-50e74cef]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px;min-width:140px}.training-instruction-record__progress-track[data-v-50e74cef]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:80px;height:8px;background:#e5e7eb;border-radius:999px;overflow:hidden}.training-instruction-record__progress-bar[data-v-50e74cef]{height:100%;background:#2563eb;border-radius:999px;-webkit-transition:width .2s ease;transition:width .2s ease}.training-instruction-record__progress-text[data-v-50e74cef]{-ms-flex-negative:0;flex-shrink:0;color:#606266;font-size:13px;white-space:nowrap}.training-instruction-record__score[data-v-50e74cef]{font-weight:500}.training-instruction-record__score.is-pass[data-v-50e74cef]{color:#16a34a}.training-instruction-record__score.is-fail[data-v-50e74cef]{color:#dc2626}.training-instruction-record__action-link[data-v-50e74cef]{display:inline-block;padding:4px 10px;border-radius:4px;font-size:12px;line-height:18px;font-weight:500;color:#409eff;text-decoration:none}.training-instruction-record__action-link[data-v-50e74cef]:hover{background:#ecf5ff}.training-instruction-record .pagination[data-v-50e74cef]{margin:16px auto 0;text-align:center}@media (max-width:1200px){.training-instruction-record__search-grid[data-v-50e74cef]{grid-template-columns:repeat(2,minmax(0,1fr))}}@media (max-width:768px){.training-instruction-record__search-grid[data-v-50e74cef]{grid-template-columns:1fr}}", "", {"version":3,"sources":["/workspace/src/views/training/pages/instruction/TrainingInstructionRecordTable.vue"],"names":[],"mappings":"AACA,oDAAoD,gBAAgB,kBAAkB,6CAA8C,qCAAsC,eAAe,CACxL,AACD,uFAAuF,eAAe,CACrG,AACD,2DAA2D,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,yBAAyB,sBAAsB,8BAA8B,kBAAkB,gCAAgC,eAAe,yBAAyB,sBAAsB,qBAAqB,iBAAiB,cAAc,eAAe,eAAe,CAChc,AACD,6DAA6D,aAAa,CACzE,AACD,mEAAmE,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,OAAO,CAChM,AACD,kIAAkI,eAAe,UAAU,QAAQ,CAClK,AACD,6DAA6D,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,WAAW,YAAY,UAAU,SAAS,cAAc,oBAAoB,cAAc,aAAa,CACnX,AACD,+DAA+D,cAAc,CAC5E,AACD,2DAA2D,sBAAsB,CAChF,AACD,2DAA2D,aAAa,8CAAgD,aAAa,CACpI,AACD,8DAA8D,oBAAoB,oBAAoB,aAAa,mBAAmB,eAAe,SAAS,eAAe,eAAe,CAC3L,AACD,yDAAyD,mBAAmB,CAC3E,AACD,0DAA0D,yBAAyB,kBAAkB,eAAe,CACnH,AACD,iEAAiE,mBAAmB,cAAc,eAAe,eAAe,CAC/H,AACD,iEAAiE,eAAe,aAAa,CAC5F,AACD,sFAAsF,kBAAkB,CACvG,AACD,qEAAsE,YAAY,CACjF,AACD,mDAAmD,qBAAqB,iBAAiB,oBAAoB,eAAe,iBAAiB,gBAAgB,kBAAkB,CAC9K,AACD,6DAA6D,mBAAmB,aAAa,CAC5F,AACD,6DAA6D,mBAAmB,aAAa,CAC5F,AACD,2DAA2D,mBAAmB,aAAa,CAC1F,AACD,sEAAsE,mBAAmB,aAAa,CACrG,AACD,6DAA6D,mBAAmB,aAAa,CAC5F,AACD,+DAA+D,mBAAmB,aAAa,CAC9F,AACD,8DAA8D,mBAAmB,aAAa,CAC7F,AACD,gEAAgE,mBAAmB,aAAa,CAC/F,AACD,gEAAgE,mBAAmB,aAAa,CAC/F,AACD,6DAA6D,mBAAmB,aAAa,CAC5F,AACD,yHAAyH,mBAAmB,aAAa,CACxJ,AACD,8DAA8D,mBAAmB,aAAa,CAC7F,AACD,sDAAsD,gBAAgB,cAAc,eAAe,2CAA8C,CAChJ,AACD,qDAAqD,aAAa,CACjE,AACD,wDAAwD,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,SAAS,eAAe,CACtM,AACD,8DAA8D,mBAAmB,WAAW,OAAO,eAAe,WAAW,mBAAmB,oBAAoB,eAAe,CAClL,AACD,4DAA4D,YAAY,mBAAmB,oBAAoB,kCAAmC,yBAA0B,CAC3K,AACD,6DAA6D,oBAAoB,cAAc,cAAc,eAAe,kBAAkB,CAC7I,AACD,qDAAqD,eAAe,CACnE,AACD,6DAA6D,aAAa,CACzE,AACD,6DAA6D,aAAa,CACzE,AACD,2DAA2D,qBAAqB,iBAAiB,kBAAkB,eAAe,iBAAiB,gBAAgB,cAAc,oBAAoB,CACpM,AACD,iEAAiE,kBAAkB,CAClF,AACD,0DAA0D,mBAAmB,iBAAiB,CAC7F,AACD,0BACA,2DAA2D,6CAA+C,CACzG,CACA,AACD,yBACA,2DAA2D,yBAAyB,CACnF,CACA","file":"TrainingInstructionRecordTable.vue","sourcesContent":["\n.training-instruction-record__card[data-v-50e74cef]{background:#fff;border-radius:8px;-webkit-box-shadow:0 1px 3px rgba(0,0,0,0.08);box-shadow:0 1px 3px rgba(0,0,0,0.08);overflow:hidden\n}\n.training-instruction-record__card+.training-instruction-record__card[data-v-50e74cef]{margin-top:16px\n}\n.training-instruction-record__card-header[data-v-50e74cef]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:12px 24px;border-bottom:1px solid #ebeef5;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:#606266;font-size:14px;font-weight:500\n}\n.training-instruction-record__card-header i[data-v-50e74cef]{color:#909399\n}\n.training-instruction-record__card-header-actions[data-v-50e74cef]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px\n}\n.training-instruction-record__card-header-actions ::v-deep .training-instruction-record__header-action.el-button[data-v-50e74cef]{min-width:24px;padding:0;margin:0\n}\n.training-instruction-record__header-action[data-v-50e74cef]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:24px;height:24px;padding:0;margin:0;color:#909399;-ms-flex-negative:0;flex-shrink:0;line-height:1\n}\n.training-instruction-record__header-action i[data-v-50e74cef]{font-size:14px\n}\n.training-instruction-record__search-form[data-v-50e74cef]{padding:16px 24px 20px\n}\n.training-instruction-record__search-grid[data-v-50e74cef]{display:grid;grid-template-columns:repeat(3, minmax(0, 1fr));gap:12px 16px\n}\n.training-instruction-record__search-actions[data-v-50e74cef]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:12px;margin-top:4px;padding-top:4px\n}\n.training-instruction-record__list-body[data-v-50e74cef]{padding:0 16px 16px\n}\n.training-instruction-record__table-wrap[data-v-50e74cef]{border:1px solid #ebeef5;border-radius:8px;overflow:hidden\n}\n.training-instruction-record__table ::v-deep th[data-v-50e74cef]{background:#f5f7fa;color:#909399;font-size:12px;font-weight:500\n}\n.training-instruction-record__table ::v-deep td[data-v-50e74cef]{font-size:14px;color:#303133\n}\n.training-instruction-record__table ::v-deep .el-table__row:hover>td[data-v-50e74cef]{background:#fafafa\n}\n.training-instruction-record__table[data-v-50e74cef] ::v-deep::before{display:none\n}\n.training-instruction-record__tag[data-v-50e74cef]{display:inline-block;padding:2px 10px;border-radius:999px;font-size:12px;line-height:20px;font-weight:500;white-space:nowrap\n}\n.training-instruction-record__tag.is-worker[data-v-50e74cef]{background:#dbeafe;color:#1d4ed8\n}\n.training-instruction-record__tag.is-intern[data-v-50e74cef]{background:#ede9fe;color:#6d28d9\n}\n.training-instruction-record__tag.is-task[data-v-50e74cef]{background:#e0e7ff;color:#4338ca\n}\n.training-instruction-record__tag.is-learning-center[data-v-50e74cef]{background:#cffafe;color:#0e7490\n}\n.training-instruction-record__tag.is-assign[data-v-50e74cef]{background:#f3e8ff;color:#7e22ce\n}\n.training-instruction-record__tag.is-learning[data-v-50e74cef]{background:#dbeafe;color:#1d4ed8\n}\n.training-instruction-record__tag.is-learned[data-v-50e74cef]{background:#dcfce7;color:#15803d\n}\n.training-instruction-record__tag.is-wait-exam[data-v-50e74cef]{background:#fef9c3;color:#a16207\n}\n.training-instruction-record__tag.is-examining[data-v-50e74cef]{background:#ffedd5;color:#c2410c\n}\n.training-instruction-record__tag.is-passed[data-v-50e74cef]{background:#d1fae5;color:#047857\n}\n.training-instruction-record__tag.is-failed[data-v-50e74cef],.training-instruction-record__tag.is-retry[data-v-50e74cef]{background:#fee2e2;color:#dc2626\n}\n.training-instruction-record__tag.is-default[data-v-50e74cef]{background:#f3f4f6;color:#6b7280\n}\n.training-instruction-record__sub-id[data-v-50e74cef]{margin-left:4px;color:#c0c4cc;font-size:12px;font-family:Menlo, Monaco, Consolas, monospace\n}\n.training-instruction-record__empty[data-v-50e74cef]{color:#c0c4cc\n}\n.training-instruction-record__progress[data-v-50e74cef]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px;min-width:140px\n}\n.training-instruction-record__progress-track[data-v-50e74cef]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:80px;height:8px;background:#e5e7eb;border-radius:999px;overflow:hidden\n}\n.training-instruction-record__progress-bar[data-v-50e74cef]{height:100%;background:#2563eb;border-radius:999px;-webkit-transition:width 0.2s ease;transition:width 0.2s ease\n}\n.training-instruction-record__progress-text[data-v-50e74cef]{-ms-flex-negative:0;flex-shrink:0;color:#606266;font-size:13px;white-space:nowrap\n}\n.training-instruction-record__score[data-v-50e74cef]{font-weight:500\n}\n.training-instruction-record__score.is-pass[data-v-50e74cef]{color:#16a34a\n}\n.training-instruction-record__score.is-fail[data-v-50e74cef]{color:#dc2626\n}\n.training-instruction-record__action-link[data-v-50e74cef]{display:inline-block;padding:4px 10px;border-radius:4px;font-size:12px;line-height:18px;font-weight:500;color:#409eff;text-decoration:none\n}\n.training-instruction-record__action-link[data-v-50e74cef]:hover{background:#ecf5ff\n}\n.training-instruction-record .pagination[data-v-50e74cef]{margin:16px auto 0;text-align:center\n}\n@media (max-width: 1200px){\n.training-instruction-record__search-grid[data-v-50e74cef]{grid-template-columns:repeat(2, minmax(0, 1fr))\n}\n}\n@media (max-width: 768px){\n.training-instruction-record__search-grid[data-v-50e74cef]{grid-template-columns:1fr\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5628:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5629);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("7576cca9", content, true, {});

/***/ }),

/***/ 5629:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".training-instruction-record__search-form .el-form-item{margin-bottom:0}.training-instruction-record__search-form .el-form-item__label{color:#606266;font-size:13px;line-height:32px}", "", {"version":3,"sources":["/workspace/src/views/training/pages/instruction/TrainingInstructionRecordTable.vue"],"names":[],"mappings":"AACA,wDAAwD,eAAe,CACtE,AACD,+DAA+D,cAAc,eAAe,gBAAgB,CAC3G","file":"TrainingInstructionRecordTable.vue","sourcesContent":["\n.training-instruction-record__search-form .el-form-item{margin-bottom:0\n}\n.training-instruction-record__search-form .el-form-item__label{color:#606266;font-size:13px;line-height:32px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5630:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTrainingInstructionRecordTableFields;
function createTrainingInstructionRecordTableFields(vm) {
  return [{ key: 'id', prop: 'id', label: '记录ID', width: 90 }, { key: 'instruction_id', label: '培训ID', width: 90, formatter: function formatter() {
      return vm.instruction.id;
    } }, {
    key: 'training_instruction_title',
    prop: 'training_instruction_title',
    label: '培训标题',
    minWidth: 160,
    showOverflowTooltip: true
  }, { key: 'userid', label: '用户ID', width: 90, formatter: function formatter(row) {
      return row.userid;
    } }, { key: 'realname', prop: 'realname', label: '真实姓名', minWidth: 100, showOverflowTooltip: true }, { key: 'region_name', prop: 'region_name', label: '省市区', minWidth: 160, showOverflowTooltip: true }, {
    key: 'target_usertype',
    label: '用户类型',
    width: 110,
    slot: 'tag',
    formatter: function formatter(row) {
      return row.target_usertype_name;
    },
    tagClass: function tagClass(row) {
      return vm.getUserTypeTagClass(row.target_usertype);
    }
  }, {
    key: 'source_type',
    label: '来源',
    width: 120,
    slot: 'tag',
    formatter: function formatter(row) {
      return row.source_type_name;
    },
    tagClass: function tagClass(row) {
      return vm.getSourceTypeTagClass(row.source_type);
    }
  }, { key: 'project', label: '项目', minWidth: 160, slot: 'project' }, { key: 'batch', label: '批次', minWidth: 160, slot: 'subId', nameKey: 'batch_name', idKey: 'batchid' }, { key: 'task', label: '任务', minWidth: 160, slot: 'subId', nameKey: 'task_title', idKey: 'taskid' }, {
    key: 'instruction_record_status',
    label: '培训状态',
    width: 110,
    slot: 'tag',
    formatter: function formatter(row) {
      return row.instruction_record_status_name;
    },
    tagClass: function tagClass(row) {
      return vm.getRecordStatusTagClass(row.instruction_record_status);
    }
  }, { key: 'learning_progress', label: '学习进度', width: 180, slot: 'progress' }, { key: 'examination_score', label: '考试分数', width: 100, slot: 'score' }, { key: 'learning_started_at', label: '开始学习时间', width: 170, slot: 'datetime', prop: 'learning_started_at' }, { key: 'learning_finished_at', label: '完成学习时间', width: 170, slot: 'datetime', prop: 'learning_finished_at' }, { key: 'examination_submitted_at', label: '考试提交时间', width: 170, slot: 'datetime', prop: 'examination_submitted_at' }];
}

/***/ }),

/***/ 5631:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],staticClass:"training-instruction-record"},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("考试培训管理")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":{ path: '/training/instruction' }}},[_vm._v("培训管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('training-instruction-sub-heading',{attrs:{"title":_vm.pageHeadingTitle,"entity-id":_vm.instruction.id}}),_vm._v(" "),_c('div',{staticClass:"training-instruction-record__card training-instruction-record__card--search"},[_c('div',{staticClass:"training-instruction-record__card-header",on:{"click":function($event){_vm.searchExpanded = !_vm.searchExpanded}}},[_c('span',[_vm._v("搜索")]),_vm._v(" "),_c('i',{class:_vm.searchExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'})]),_vm._v(" "),_c('el-form',{directives:[{name:"show",rawName:"v-show",value:(_vm.searchExpanded),expression:"searchExpanded"}],ref:"searchForm",staticClass:"training-instruction-record__search-form",attrs:{"model":_vm.search,"label-width":"96px","label-position":"left","size":"small"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('div',{staticClass:"training-instruction-record__search-grid"},[_c('el-form-item',{attrs:{"label":"关键字","prop":"keyword"}},[_c('el-input',{attrs:{"placeholder":"请输入真实姓名或ID","clearable":""},model:{value:(_vm.search.keyword),callback:function ($$v) {_vm.$set(_vm.search, "keyword", $$v)},expression:"search.keyword"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"培训状态","prop":"instruction_record_status"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"请选择"},model:{value:(_vm.search.instruction_record_status),callback:function ($$v) {_vm.$set(_vm.search, "instruction_record_status", $$v)},expression:"search.instruction_record_status"}},_vm._l((_vm.opts.recordStatusMaps),function(it){return _c('el-option',{key:it.value,attrs:{"label":it.label,"value":Number(it.value)}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"用户类型","prop":"target_usertype"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"请选择"},model:{value:(_vm.search.target_usertype),callback:function ($$v) {_vm.$set(_vm.search, "target_usertype", $$v)},expression:"search.target_usertype"}},_vm._l((_vm.targetUserMaps),function(it){return _c('el-option',{key:it.value,attrs:{"label":it.label,"value":Number(it.value)}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"来源","prop":"source_type"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"请选择"},model:{value:(_vm.search.source_type),callback:function ($$v) {_vm.$set(_vm.search, "source_type", $$v)},expression:"search.source_type"}},_vm._l((_vm.opts.sourceTypeMaps),function(it){return _c('el-option',{key:it.value,attrs:{"label":it.label,"value":Number(it.value)}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目","prop":"projectid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"number","label-key":"name","value-key":"id","placeholder":"请输入项目 名称/编号 进行搜索","query-request":_vm.getProjectTable,"find-request":_vm.getProjectDetail},on:{"change":function($event){_vm.search.batchid = null}},model:{value:(_vm.search.projectid),callback:function ($$v) {_vm.$set(_vm.search, "projectid", $$v)},expression:"search.projectid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"批次","prop":"batchid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","disabled":!_vm.search.projectid,"id-key":"number","label-key":"detail","value-key":"id","placeholder":"请输入批次 名称/编号 进行搜索","query-request":function (_) { return _vm.getBatchTable(Object.assign({ projectid: _vm.search.projectid }, _)); },"find-request":_vm.getBatchDetail},model:{value:(_vm.search.batchid),callback:function ($$v) {_vm.$set(_vm.search, "batchid", $$v)},expression:"search.batchid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"省市区","prop":"regionids"}},[_c('el-cascader',{staticClass:"width-max",attrs:{"options":_vm.chinaAreaData,"props":{ multiple: true, checkStrictly: true },"filterable":"","clearable":"","placeholder":"请选择省市区"},model:{value:(_vm.search.regionids),callback:function ($$v) {_vm.$set(_vm.search, "regionids", $$v)},expression:"search.regionids"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"完成学习","prop":"learning_finished_at"}},[_c('el-date-picker',{staticClass:"width-max",attrs:{"value-format":"yyyy-MM-dd HH:mm:ss","type":"datetimerange","picker-options":_vm.dateTimePickerRangeOptions,"range-separator":"至","start-placeholder":"开始时间","end-placeholder":"结束时间","default-time":['00:00:00', '23:59:59'],"clearable":""},model:{value:(_vm.search.learning_finished_at),callback:function ($$v) {_vm.$set(_vm.search, "learning_finished_at", $$v)},expression:"search.learning_finished_at"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"考试提交","prop":"examination_submitted_at"}},[_c('el-date-picker',{staticClass:"width-max",attrs:{"value-format":"yyyy-MM-dd HH:mm:ss","type":"datetimerange","picker-options":_vm.dateTimePickerRangeOptions,"range-separator":"至","start-placeholder":"开始时间","end-placeholder":"结束时间","default-time":['00:00:00', '23:59:59'],"clearable":""},model:{value:(_vm.search.examination_submitted_at),callback:function ($$v) {_vm.$set(_vm.search, "examination_submitted_at", $$v)},expression:"search.examination_submitted_at"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"training-instruction-record__search-actions"},[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit"}},[_vm._v("搜索")]),_vm._v(" "),_c('el-button',{attrs:{"icon":"el-icon-refresh"},on:{"click":function($event){return _vm.resetSearch()}}},[_vm._v("重置")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"training-instruction-record__card"},[_c('div',{staticClass:"training-instruction-record__card-header",on:{"click":function($event){_vm.listExpanded = !_vm.listExpanded}}},[_c('span',[_vm._v("用户培训记录")]),_vm._v(" "),_c('div',{staticClass:"training-instruction-record__card-header-actions"},[_c('el-button',{staticClass:"training-instruction-record__header-action",attrs:{"type":"text","icon":"el-icon-setting","title":"列配置"},on:{"click":function($event){$event.stopPropagation();return _vm.openTableColumnConfigDialog($event)}}}),_vm._v(" "),_c('el-button',{staticClass:"training-instruction-record__header-action",attrs:{"type":"text","icon":"el-icon-refresh"},on:{"click":function($event){$event.stopPropagation();return _vm.onRefresh()}}}),_vm._v(" "),_c('span',{staticClass:"training-instruction-record__header-action"},[_c('i',{class:_vm.listExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'})])],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.listExpanded),expression:"listExpanded"}],staticClass:"training-instruction-record__list-body"},[_c('div',{staticClass:"training-instruction-record__table-wrap"},[_c('el-table',{key:_vm.tableColumnRenderKey,staticClass:"training-instruction-record__table",staticStyle:{"width":"100%"},attrs:{"data":_vm.table}},[_vm._l((_vm.activeTableFields),function(field){return _c('el-table-column',_vm._b({key:field.key,scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(field.slot === 'tag')?_c('span',[(field.formatter(scope.row))?_c('span',{class:['training-instruction-record__tag', field.tagClass(scope.row)]},[_vm._v("\n                    "+_vm._s(field.formatter(scope.row))+"\n                  ")]):_c('span',{staticClass:"training-instruction-record__empty"},[_vm._v("-")])]):(field.slot === 'project')?[(_vm.isLearningCenterSource(scope.row))?[_c('span',{staticClass:"training-instruction-record__empty"},[_vm._v("-")])]:(scope.row.projectid)?[_c('span',[_vm._v(_vm._s(scope.row.project_name))]),_vm._v(" "),_c('span',{staticClass:"training-instruction-record__sub-id"},[_vm._v("/ "+_vm._s(scope.row.projectid))])]:_c('span',{staticClass:"training-instruction-record__empty"},[_vm._v("-")])]:(field.slot === 'subId')?[(scope.row[field.idKey])?[_c('span',[_vm._v(_vm._s(scope.row[field.nameKey]))]),_vm._v(" "),_c('span',{staticClass:"training-instruction-record__sub-id"},[_vm._v("/ "+_vm._s(scope.row[field.idKey]))])]:_c('span',{staticClass:"training-instruction-record__empty"},[_vm._v("-")])]:(field.slot === 'progress')?[(_vm.hasLearningProgress(scope.row))?[_c('div',{staticClass:"training-instruction-record__progress"},[_c('div',{staticClass:"training-instruction-record__progress-track"},[_c('div',{staticClass:"training-instruction-record__progress-bar",style:({ width: _vm.getLearningProgress(scope.row) + '%' })})]),_vm._v(" "),_c('span',{staticClass:"training-instruction-record__progress-text"},[_vm._v(_vm._s(_vm.getLearningProgress(scope.row))+"%")])])]:_c('span',{staticClass:"training-instruction-record__empty"},[_vm._v("-")])]:(field.slot === 'score')?_c('span',[(_vm.isOpenBookExamRow(scope.row))?_c('span',{staticClass:"training-instruction-record__empty"},[_vm._v("-")]):(_vm.hasExaminationScore(scope.row))?_c('span',{class:['training-instruction-record__score', _vm.getExamScoreClass(scope.row)]},[_vm._v("\n                    "+_vm._s(scope.row.examination_score)+"分\n                  ")]):_c('span',{staticClass:"training-instruction-record__empty"},[_vm._v("-")])]):(field.slot === 'datetime')?_c('span',{class:{ 'training-instruction-record__empty': !scope.row[field.prop] }},[_vm._v("\n                  "+_vm._s(scope.row[field.prop] || '-')+"\n                ")]):[_vm._v("\n                  "+_vm._s(field.formatter ? field.formatter(scope.row) : scope.row[field.prop])+"\n                ")]]}}],null,true)},'el-table-column',_vm.getFieldColumnBind(field),false))}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"100","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.canViewExamDetail(scope.row))?_c('router-link',{staticClass:"training-instruction-record__action-link",attrs:{"to":_vm.getExamDetailLink(scope.row)}},[_vm._v("\n                  查看答卷\n                ")]):_vm._e()]}}])})],2)],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)])]),_vm._v(" "),_c('table-column-config-dialog',{attrs:{"visible":_vm.tableColumnConfigDialogVisible,"applied-columns":_vm.tableColumnAppliedConfig,"definitions":_vm.fields},on:{"update:visible":function($event){_vm.tableColumnConfigDialogVisible=$event},"save":_vm.onTableColumnConfigSave}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/training-instruction-records.35676f26cb8fc9cb87fc.js